import axios from 'axios';

import type { TemaConfigurado } from '../shared/tema/tema';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const authHeader = (): Record<string, string> => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Tema da aplicação (at-130): a escolha de CADA usuário (claro, escuro ou seguir o sistema),
 * gravada no servidor para valer em qualquer computador.
 * Sem catch aqui (regra da at-60) — quem trata o erro é quem chama.
 */
export interface TemaDaAplicacao {
  tema: TemaConfigurado;
}

export async function obterTemaDaAplicacao(): Promise<TemaDaAplicacao> {
  const { data } = await axios.get<TemaDaAplicacao>(`${BACKEND_URL}/aparencia/tema`, { headers: authHeader() });
  return data;
}

export async function salvarTemaDaAplicacao(tema: TemaConfigurado): Promise<TemaDaAplicacao> {
  const { data } = await axios.put<TemaDaAplicacao>(
    `${BACKEND_URL}/aparencia/tema`,
    { tema },
    { headers: authHeader() },
  );
  return data;
}
